/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.12.5",
    versionName: "0.2.0-nightly.2025.12.5",
    versionChannel: "nightly",
    buildDate: "2025-12-05T00:07:51.845Z",
    commitHash: "ba18b3d78719828c0c609e750ff7f58f0c777ab7",
};
